import { defineStore } from 'pinia';
import FIMenuForCustomerMeeting from '@core/classes/FIMenuForCustomerMeeting';
import { ref } from 'vue';

export const useFIMenuForCustomerMeetingStore = defineStore('fimenuForCustomerMeeting', () => {
	// State
	const fimenu = ref<FIMenuForCustomerMeeting | null>(null);

	function clearFIMenu() {
		fimenu.value = new FIMenuForCustomerMeeting();
	}

	function setFIMenu(newFIMenu: FIMenuForCustomerMeeting) {
		fimenu.value = new FIMenuForCustomerMeeting(newFIMenu);
	}

	return {
		fimenu,
		clearFIMenu,
		setFIMenu,
	};
});
